import { ethereum } from '@0xtorch/core'
import { worldchain } from 'viem/chains'
import type { Client } from '../../client'
import { createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createEtherscanV2 } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createWorldChain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}): Chain =>
  createWorldChainCustom({
    client: createClient({ chain: worldchain, httpRpcs: worldChainHttpRpcs }),
    explorer: createEtherscanV2({
      name: 'World Scan',
      baseUrl: 'https://worldscan.org',
      chainId: 480,
      apiKey,
      proxyUrl,
      pageSize,
    }),
  })

type CreateWorldChainCustomParameters = {
  client: Client
  explorer: Explorer
}

export const createWorldChainCustom = ({
  client,
  explorer,
}: CreateWorldChainCustomParameters): Chain => ({
  id: 480,
  network: 'world-chain',
  name: 'World Chain',
  nativeToken: {
    name: 'Ethereum',
    symbol: 'ETH',
    decimals: 18,
    currency: ethereum,
  },
  wrappedTokenAddresses: new Set([
    '0x4200000000000000000000000000000000000006',
  ]),
  explorer,
  client,
  blockTime: 2000,
  coingeckoId: 'world-chain',
  defillamaId: undefined,
})

export const worldChainHttpRpcs: HttpRpc[] = [
  {
    url: 'https://worldchain-mainnet.g.alchemy.com/public',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://480.rpc.thirdweb.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 1000n,
  },
  {
    url: 'https://worldchain-mainnet.gateway.tenderly.co',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://sparkling-autumn-dinghy.worldchain-mainnet.quiknode.pro',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://worldchain.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const worldChainWebsocketRpcUrls: string[] = [
  'wss://worldchain-mainnet.gateway.tenderly.co',
  'wss://worldchain.drpc.org',
]
